import React, { useEffect, useState, useContext, useCallback } from "react";

import { ModalBodyContainer } from "App/styles";

import {
  ViewHeader,
  ViewHeading,
  ViewEyebrow,
  ViewTitle,
  CloseButton,
} from "./styles";

import Form from "components/Form";

import { MainTitle } from "components/MainTitle";
import { useLocation } from "wouter";
import useEntryForm from "hooks/useEntryForm";

import { AlertContext } from "contexts/AlertContext";
import { MessageType } from "model/dictionary";
import CloseIcon from "icons/CloseIcon";

export default function ViewEntry({ params }) {
  const { loadingForm, getEntryForm, initialForm } = useEntryForm();
  const [, navigate] = useLocation();
  const { showAlert } = useContext(AlertContext);
  const [form, setForm] = useState(initialForm);

  // Esta pantalla se usa de dos maneras: como ruta propia
  // (/visualizar-postulacion/:entryId) y dentro del modal del listado de
  // postulaciones, que es el único que pasa `onClose`.
  const inModal = Boolean(params.onClose);

  useEffect(() => {
    getEntryForm(params.entryId).then((data) => {
      if (!data.exists) {
        showAlert(MessageType.DANGER, "El formulario no existe", 3000, () => {
          navigate("/");
        });
      } else {
        setForm(data.form);
      }
    });
  }, [getEntryForm, navigate, params.entryId, showAlert]);

  const formCompleted = useCallback(
    (status) => {
      navigate("/");
    },
    [navigate]
  );

  const awardTitle = (form.award && form.award.title) || "Postulación";

  return (
    <ModalBodyContainer>
      {inModal ? (
        <ViewHeader className="no-print">
          <ViewHeading>
            <ViewEyebrow>
              {form.entryNumber ? `Postulación N° ${form.entryNumber}` : "Postulación"}
            </ViewEyebrow>
            <ViewTitle>{awardTitle}</ViewTitle>
          </ViewHeading>

          <CloseButton
            type="button"
            onClick={params.onClose}
            aria-label="Cerrar la postulación"
          >
            <CloseIcon />
          </CloseButton>
        </ViewHeader>
      ) : (
        <MainTitle title={"Formulario"} seoTitle={"Formulario"} />
      )}

      <Form
        onCompleted={formCompleted}
        currentStatus="view"
        readOnly={true}
        form={form}
        onClose={params.onClose}
        loading={loadingForm}
        inModal={inModal}
      />
    </ModalBodyContainer>
  );
}
